<template>
    <v-text-field v-bind="$attrs">
        <template #prepend-inner>
            <slot />
        </template>
    </v-text-field>
</template>

<script>
export default {};
</script>


<style lang="scss" scoped>
::v-deep {
    .v-input__prepend-inner {
        flex: 1 0 auto;
        display: block;
        padding: 0 !important;
        margin: 0 !important;
    }
    .v-text-field__slot {
        flex: 0 1 0 !important;

        & > label {
            max-width: initial;
            width: initial;
            transition: none;
        }
    }
}
</style>